module.exports = __webpack_public_path__ + "img/difficultyLevel_1.1423d5d7.svg";